module.exports = __webpack_public_path__ + "img/messenger@2x.c2f79ff3.png";